
import { Component, Vue } from 'vue-property-decorator';
import PageTitle from '@/UI/components/common/PageTitle.vue';
import FiltersComponent from '@/UI/components/filter/FiltersComponent.vue';
import { Button, Menu, List, Table, Select, Row } from 'ant-design-vue';
import { VisitsMix } from '@/UI/mixins/Clients/VisitsMix';
import { VisitsTableMix } from '@/UI/mixins/Clients/VisitsTableMix';
import BaseDataForm from '@/UI/components/Helpers/BaseForm/BaseDataForm.vue';
import { mixins } from 'vue-class-component';
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import { getStudioId } from '@/UI/lib/state';
import { ProxyGetData } from '../Helpers/getData';

@Component({
    components: {
        'a-button': Button,
        'a-menu-item': Menu.Item,
        'a-list-item': List.Item,
        'a-list-item-meta': List.Item.Meta,
        'a-select': Select,
        'a-select-option': Select.Option,
        'a-table': Table,
        'a-row': Row,
        BaseDataForm,
        FiltersComponent,
        PageTitle,
        SortComponent
    },
})

export default class ClientsHistory extends mixins(
    VisitsMix,
    VisitsTableMix,
    ProxyGetData
) {
    async created(): Promise<void> {
        if (!this.formReady) {
            try {
                this.proxyFilter = {
                    salon_id: getStudioId(this),
                    status_id: 2,
                    client_id: Vue.router.currentRoute.params['id']
                }
                await this.sortedData('desc', {dataIndex: 'visit_dt'})
            } catch (e) {
                console.log(e)
            } finally {
                this.formReady = true;
            }
        }
    }
}
